/**
 * Sets up vue component watch with single method handling for bulk properties.
 *
 * @since 0.1.27
 *
 * @param  {Array}  toWatch Array of props/computed/etc to watch.
 * @param  {string} method  The method in the methods property of the component to call.
 *
 * @returns {Object}         A watch object.
 */
export default (toWatch, method) => {
	const watch = {};
	toWatch.forEach((prop) => {
		const func = new Function( // eslint-disable-line no-new-func
			`return function ${prop}(newVal, oldVal){this.${method}(newVal, oldVal, '${prop}')}`
		)();
		watch[prop] = func;
	});
	return watch;
};
